// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.success-color[data-v-9d541932] {\r\n  color: #35a744 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
